import { Component } from '@angular/core';
import { NavController, Events, LoadingController } from 'ionic-angular';
import { UserData } from '../../../../providers/user-data';
import { PageBase } from '../../../../core/page-base';
import { AppSettings } from '../../../../config/app-settings';
import { DynamicPageCommon } from './dynamic-page.common';

@Component({
	selector: 'dynamic-page',
  	templateUrl: 'dynamic-page.html'
})

export class DynamicPage extends PageBase {
	public pageId: any;
	public loader: any;
	public pageData: any;

	constructor(
		public settings: AppSettings,
		public events: Events,
		public nav: NavController,
		public userData: UserData,
		public common: DynamicPageCommon,
        public loadingCtrl: LoadingController
	) {
		super(settings, events, nav, userData);
		this.loader = this.loadingCtrl.create();
	}

	ngAfterViewInit() {
		let self = this;
		self.loader.present();
		self.common.getPageData(self.pageId).subscribe((data) =>{
			self.pageData = data.text;
			self.loader.dismiss();
		});
	}

	ionViewDidEnter() {
		
	}
}





// WEBPACK FOOTER //
// ./src/modules/dynamic-page/pages/dynamic-page/dynamic-page.ts